import { ChangeDetectorRef, Component, Inject, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { InovaCommonGraphqlApi } from 'inova-front-core/helpers/services/http';
import { NAV_MAPPED_SERVICES, NAV_SERVICES_BY_ROLE, NavEnvironment, NavServices, NavServicesMap, NavUserProfileOption } from '../env/environment.interface';
import { NAV_ENVIRONMENT } from '../env/environment.nav';
import { MediaMatcher } from '@angular/cdk/layout';
import { Router } from '@angular/router';
import { SessionDataService } from 'inova-front-core/session'
import { UserData } from 'inova-front-core/session'
import { InovaNavGraphqlApi } from '../services/nav-api.service';
import { zip } from 'rxjs';


export enum ChatState{
  initiated = 1,
  active,
  finished,
  paused
}

@Component({
  selector: 'inova-nav',
  templateUrl: './inova-nav.component.html',
  styleUrls: ['./inova-nav.component.scss']
})
export class InovaNavComponent implements OnInit {
  
  @Input()
  userProfileOptions:NavUserProfileOption[]=[];

  @Input()
  hideWhileLoading:boolean = false;

  options: NavServicesMap[] = [];
  private mobileQueryListener: () => void;
  mobileQuery: MediaQueryList;
  user: any = {};
  isExpanded: boolean = true;

  notificationsCount=0;

  redirect=false;
  
  loading: boolean = true;
  frames: any = [];
  constructor(private sanitizer: DomSanitizer,
    @Inject(NAV_ENVIRONMENT) private env: NavEnvironment,
    private apiServiceService: InovaCommonGraphqlApi,
    private inovaNavGraphqlApi:InovaNavGraphqlApi,
    media: MediaMatcher,
    changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    private sessionService: SessionDataService
  ) {
    this.mobileQuery = media.matchMedia('(max-width: 1000px)');
    this.mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this.mobileQueryListener);
    this.sessionService.setLoginUrl(env.logout);
  }

  ngOnInit(): void {
    this.loading = true;
   
    this.validateUser();
  }

  getCurrentOptionTitle(){
    return this.options.find(x=>x.current)?.service
  }

  setIframes(){
    this.frames = this.options.filter(x => !x.current).map((x, i: number) => {
      return {
        route: this.sanitizer.bypassSecurityTrustResourceUrl(x.url + '/session-listener'),
        id: 'fr-listener-' + i
      }
    })
  }

  toggleOptions() {
    this.isExpanded = !this.isExpanded;
  }

  validateUser() {
    this.apiServiceService.getUserRole().subscribe((userData: UserData) => {
      this.setPerson(userData);
      this.evaluateRole(userData);
    });
  }

  setPerson(user: UserData){
    if (user.persona) {
      this.user = user.persona;
    }
    else {
      if (user.productor?.persona) {
        this.user = user.productor.persona;
      }
    }
  }

  set_cliente_services(){
    const baseServices=NAV_SERVICES_BY_ROLE.cliente;
    this.apiServiceService.getClientServices().subscribe(x=>{
      const clientServices=x[0];
      this.sessionService.setUserServices(clientServices);
      const hasComService=clientServices.botAsistenciaTecnica || clientServices.cursos || clientServices.campanias;
      if(!hasComService){
        const index=baseServices.indexOf(NavServices.CM);
        if(index>=0){
          baseServices.splice(index,1);
        }
      }

      const hasRutas = clientServices.rutas;
      if (!hasRutas) {
          const index = baseServices.indexOf(NavServices.ROUTES);
          if (index >= 0) baseServices.splice(index, 1);
      }
      this.setUserFinalServices(baseServices);
    })
  }

  set_subcliente_services(){
    this.set_cliente_services();
  }

  set_analista_services(){
    const baseServices=NAV_SERVICES_BY_ROLE.analista;
    this.setUserFinalServices(baseServices);
  }

  set_profesional_services(){
    const baseServices=NAV_SERVICES_BY_ROLE.profesional;
    const requests=[
      this.inovaNavGraphqlApi.getCourses(),
      this.inovaNavGraphqlApi.getProfessionalHasContactCenter(),
      this.inovaNavGraphqlApi.getProfessionalRulesLite()
    ]
    zip(...requests).subscribe(x=>{
      if(x[1]){
        this.inovaNavGraphqlApi.getLiteUserChats([ChatState.active, ChatState.initiated]).subscribe(y=>{
          this.notificationsCount=y.length;
        })
      }
      const hasCourses=x[0] && Array.isArray(x[0]) && x[0].length>0;
      const hasContactCenter=x[1];
      const hasRules=x[2] && Array.isArray(x[2]) && x[2].length>0;
      if(!hasCourses && !hasContactCenter){
        const index=baseServices.indexOf(NavServices.CM);
        if(index>=0){
          baseServices.splice(index,1);
        }
      }
      if(!hasRules){
        const index=baseServices.indexOf(NavServices.CW);
        if(index>=0){
          baseServices.splice(index,1);
        }
      }
      this.checkProfessionalRedirect(baseServices);
      this.setUserFinalServices(baseServices);
    })
    
  }

  checkProfessionalRedirect(services:NavServices[]){
    if(services.length==1){
      if(services[0]!=this.env.current){
        this.redirect=true;
      }
    }
  }

  set_productor_services(){
    const baseServices=NAV_SERVICES_BY_ROLE.productor;
    this.setUserFinalServices(baseServices);
  }

  getMappedServices(services:NavServices[]){
    const mappedServices:NavServicesMap[]=NAV_MAPPED_SERVICES.filter(x=>services.includes(x.service));
    const envObj:any=this.env;
    mappedServices.forEach(x=>{
      x.url=envObj[x.key];
      x.current=x.service==this.env.current;
    })
    return mappedServices;
  }

  setUserFinalServices(services:NavServices[]){
    this.options=this.getMappedServices(services);
    this.loading=this.redirect;
    this.setIframes();
  }

  private evaluateRole(user: UserData) {
    const userObj:any=user;
    const navServicesObj:any=NAV_SERVICES_BY_ROLE;
    const selfObj:any=this;
    for (const key in navServicesObj) {
      if (navServicesObj.hasOwnProperty(key)) {
        if(userObj[key]){
          const methodName= `set_${key}_services`;
          if (typeof selfObj[methodName] === 'function') {
            selfObj[methodName]();
            return;
          }
        }
      }
    }
  }

  toggleMs(ms: NavServicesMap, sameTab=false) {
    if (!ms.current) {
      window.open(
        `${ms.url}`,(sameTab)?'_self':'_blank'
      );
    }
    else{
      this.isExpanded=false;
    }
  }

  getAvatarImg() {
    if(this.user?.imagenPerfil){
      return this.user?.imagenPerfil;
    }
    return "assets/images/profile.jpg"
  }

  goToOption(opcion: NavUserProfileOption) {
    return this.router.navigate(opcion.route);
  }

  signOut() {
    this.signOutMs();
    setTimeout(() => {
      this.sessionService.localLogout(true);
    }, 1000);
  }

  signOutMs() {
    this.frames.forEach((x: any) => {
      const ifr: any = document.querySelector("#" + x.id);
      if (ifr) {
        const wind = ifr.contentWindow;
        wind.postMessage(`{"type":"logout"}`, ifr.src)
      }
    })
  }

  loadIframe(ev: any) {
    if (ev.target.src) {
      const wind = ev.target.contentWindow;
      wind.postMessage(`{"type":"login","token":"${this.sessionService.getToken()}"}`, ev.target.src)
      wind.postMessage(`{"type":"loginUrl","loginUrl":"${this.env.logout}"}`, ev.target.src)
      if(this.redirect){
        setTimeout(()=>{
          setTimeout(()=>{
            this.loading=false;
          },2000)
          this.toggleMs(this.options[0],true);
        },1000);
      }
    }
  }

}
